import { createSelector } from 'reselect';
import every from 'lodash/every';
import reduce from 'lodash/reduce';
import { getAvailableRoomTypesWithFilterData } from './getAvailableRoomTypesWithFilterData';
import { getActiveFilters } from './getActiveFilters';
import { getTreatments } from 'store/split/splitSelectors';

export const getAvailableRoomTypes = createSelector(
  getAvailableRoomTypesWithFilterData,
  getActiveFilters,
  getTreatments,
  (roomTypes, activeFilters, treatments) => {
    const hasActiveFilters = !!activeFilters.length;
    const propertyPageFiltersTreatmentEnabled = treatments?.property_page_filters?.treatment === 'on';

    if (!propertyPageFiltersTreatmentEnabled || !hasActiveFilters) {
      return roomTypes;
    }

    const filteredRoomTypes = reduce(
      roomTypes,
      (accum, roomType) => {
        const offers = [];
        const result = [...accum];

        for (const offer of roomType.offers) {
          const offerMatchesActiveFilters = every(activeFilters, (filter) => !!offer.meta[filter]);

          if (offerMatchesActiveFilters) offers.push(offer);
        }

        if (offers.length) {
          result.push({ ...roomType, offers });
        }

        return result;
      },
      [],
    );

    return filteredRoomTypes;
  },
);
